import FormInputNumber from './component.jsx'
export default FormInputNumber
